import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header/Header';
import Services from './components/Services/Services';
import Map from './components/Map/Map';
import Units from './components/Units/Units';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ServicesSection from './components/ServicesSection/ServicesSection';
import HeroSection from './components/HeroSection/HeroSection';

function App() {
  return (
    <div>
      <Header />
      <HeroSection />
    
      <ServicesSection /> 
        <Services />
      <Units />
      <Map />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
